import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * The analysis history list was split into per-source pages (Email → History
 * tab, Meetings). Kept as a redirect so old links / bookmarks land somewhere
 * sensible. The per-analysis detail still lives at `/analysis/history/$id`.
 */
export const Route = createFileRoute("/_app/analysis/history/")({
  beforeLoad: () => {
    throw redirect({ to: "/agents/$slug/$tab", params: { slug: "analyst", tab: "meetings" } });
  },
});
